const PropTypes = require('prop-types');
const React = require('react');

const Option = ({ category }) =>
  <option value={category.id}>{category.displayName}</option>;

Option.propTypes = {
  category: PropTypes.object.isRequired,
};

module.exports = Option;



// WEBPACK FOOTER //
// ./javascripts/components/category_select/option.jsx